import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { url: String };
  static targets = ["subject", "message", "smsMessage", "attachIcs"];

  connect() {
    this.timeout = null;
    this.previewHandler = async (e) => {
      await this.persist();
      const frameId = e.detail?.frameId;
      const frame = document.getElementById(frameId);
      if (frame && frame.dataset.previewSrc) {
        frame.src = frame.dataset.previewSrc;
      }
    };
    this.element.addEventListener("composer-tabs:preview", this.previewHandler);
  }

  disconnect() {
    if (this.timeout) clearTimeout(this.timeout);
    this.element.removeEventListener(
      "composer-tabs:preview",
      this.previewHandler,
    );
  }

  save() {
    if (this.timeout) clearTimeout(this.timeout);
    this.timeout = setTimeout(() => this.persist(), 500);
  }

  saveAndReload() {
    if (this.timeout) clearTimeout(this.timeout);
    this.persist().then(() => {
      const frame =
        document.getElementById("composer-preview-email") ||
        document.getElementById("composer-preview-sms");
      if (!frame) return;
      const iframe = frame.querySelector("iframe");
      if (iframe?.src) {
        const url = new URL(iframe.src, window.location.origin);
        url.searchParams.set("_t", Date.now());
        iframe.src = url.toString();
      }
    });
  }

  async persist() {
    if (!this.urlValue) return;

    const body = new FormData();
    if (this.hasSubjectTarget) body.append("subject", this.subjectTarget.value);
    if (this.hasMessageTarget) body.append("message", this.messageTarget.value);
    if (this.hasSmsMessageTarget)
      body.append("sms_message", this.smsMessageTarget.value);
    if (this.hasAttachIcsTarget)
      body.append("attach_ics", this.attachIcsTarget.checked);

    const form = document.getElementById("message-form");
    const templateSelect = form?.querySelector(
      "[name='bulk_delivery[html_template_id]']",
    );
    if (templateSelect) body.append("html_template_id", templateSelect.value);

    const token = document.querySelector('meta[name="csrf-token"]')?.content;
    await fetch(this.urlValue, {
      method: "POST",
      headers: { "X-CSRF-Token": token },
      body,
    });
  }
}
